module.exports = __webpack_public_path__ + "img/client_activity.f8bead56.svg";